import { IFormItem } from '@components/Form/FormItem/FormItem';

import { DateTimeFormat } from '@/utils/dateUtils';

export const orderCardConfig = [
  {
    label: 'Дата формирования',
    key: 'createdAt',
    type: 'date',
  },
  {
    label: 'Время формирования',
    key: 'createdAt',
    type: 'time',
    placeholder: '',
    payload: { format: DateTimeFormat.TIME_SHORT },
    split: true,
  },
  {
    label: 'Дата выполнения',
    key: 'executedAt',
    type: 'date',
  },
  {
    label: 'Время выполнения',
    key: 'executedAt',
    placeholder: '',
    type: 'time',
    payload: { format: DateTimeFormat.TIME_SHORT },
  },
] as IFormItem[];
